import React from 'react';
import { Avatar, createAvatarProps } from '@usepepper/ui/atoms/avatar';
import { CompleteTranslation } from '@/types';
import { createStyles } from '@/contexts/theme-context';
import { getTranslationValue } from '@/utils/translations';
import { StyleProp, TouchableOpacity, View, ViewStyle } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';

interface Props {
  onPress?: () => void | null;
  restaurantUUID: string;
  rightElement?: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  subtitle: CompleteTranslation;
  title: CompleteTranslation;
}

export const RestaurantInfoHeader: React.FC<Props> = ({
  onPress,
  restaurantUUID,
  rightElement,
  subtitle,
  title,
  style,
}) => {
  const [styles, theme] = useStyles();
  const avatarProps = createAvatarProps(
    getTranslationValue(title),
    restaurantUUID,
  );

  return (
    <TouchableOpacity
      disabled={!onPress}
      onPress={onPress}
      style={[styles.header, style]}
    >
      <View
        style={[
          styles.leftSection,
          rightElement ? styles.leftSectionFlex : styles.flex,
        ]}
      >
        <Avatar {...avatarProps} />
        <View style={styles.flex}>
          <Typography numberOfLines={1} variant="heading-sm">
            {getTranslationValue(title)}
          </Typography>
          <Typography
            color={theme.sk.color.text.tertiary}
            numberOfLines={1}
            variant="paragraph-md"
          >
            {getTranslationValue(subtitle)}
          </Typography>
        </View>
      </View>
      {rightElement ? (
        <View style={styles.rightElement}>{rightElement}</View>
      ) : null}
    </TouchableOpacity>
  );
};

const useStyles = createStyles(() => ({
  flex: {
    flex: 1,
  },
  header: {
    flexDirection: 'row',
  },
  leftSection: {
    flexDirection: 'row',
    gap: 12,
  },
  leftSectionFlex: {
    flexGrow: 1,
    flexShrink: 1,
  },
  rightElement: {
    alignItems: 'flex-end',
    alignSelf: 'flex-start',
    flexShrink: 0,
    justifyContent: 'center',
    marginLeft: 32, // optional spacing from left content
  },
}));
